<template>
  <div class="selectcoursediv">
    <div class="selectcourse clearfix">
      <div>{{ this.form.title }}</div>
      <div class="subject-form">
        <p @click="selectcourse">{{ this.form.sname }} <span></span></p>
        <p>{{ this.form.bookname }}</p>
      </div>
    </div>
    <div class="textbooklist">
      <div class="selebooklist">
        <el-tree
          class="treelist"
          accordion
          :data="lessionData"
          :props="defaultProps"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
    </div>

    <!-- //选择弹窗 -->
    <el-dialog title="" :visible.sync="dialogFormVisible" class="bookcutpopup">
      <el-form :model="form">
        <el-form-item label="年级:" :label-width="formLabelWidth">
          <el-select v-model="form.region1" placeholder="请选择年级">
            <el-option
              v-for="item in this.gradedata"
              :key="item.gid"
              :label="item.grade_name"
              :value="item.gid"
              @click.native="changegid(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目:" :label-width="formLabelWidth">
          <el-select v-model="form.region2" placeholder="请选择科目">
            <el-option
              v-for="item in this.subjectdata"
              :key="item.sid"
              :label="item.subject_name"
              :value="item.sid"
              @click.native="changesid(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本:" :label-width="formLabelWidth">
          <el-select v-model="form.region3" placeholder="请选择版本">
            <el-option
              v-for="item in this.booklist"
              :key="item.book_id"
              :label="item.book_name"
              :value="item.book_id"
              @click.native="changebookid(item)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "../../assets/work.css";
import URL from "@/api/index";
export default {
  props: {
    lessionData: {
      type: Array,
      default: [
        {
          label: "第一章有理数",
          val: "1",
          text: "有理数",
          children: [
            {
              label: "1.1 正数和有理数",
              val: "1.1",
              text: "eee",
            },
          ],
        },
        {
          label: "第二章整式的加减法",
          val: "21",
          text: "整式的加减法",
          children: [
            {
              label: "2.1 正数和有理数",
              val: "21",
              text: "整式的加减法",
            },
          ],
        },
      ],
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      form: {
        region1: 1,
        region2: 1,
        region3: "",
        gname: "",
        sname: "",
        title: "",
        bookname: "",
      },
      Gid: 1,
      Sid: 1,
      Bookid: "",
      formLabelWidth: "120px",
      gradedata: [],
      subjectdata: [],
      booklist: [],
      formLabelWidth: "120px",
      defaultProps: {
        children: "son",
        label: "chapter_name",
      },
      subject_name: "",
    };
  },
  created() {
    this.getallgrade();
  },
  methods: {
    //选择年级
    changegid(val) {
      this.Gid = val.gid;
      this.form.gname = val.grade_name;
      this.getgetsubject();
    },
    //选择科目
    changesid(val) {
      this.Sid = val.sid;
      this.form.sname = val.subject_name;
      this.form.title = val.subject_name.substring(0, 1);
      this.getbooklist();
    },
    //选择课本
    changebookid(val) {
      this.Bookid = val.book_id;
      this.form.bookname = val.book_name;
      this.getbookchapter();
    },
    //获取年级
    getallgrade() {
      this.$post(URL.allgrade).then((res) => {
        this.gradedata = res.result.grade_list;
        this.form.gname = res.result.grade_list[0].grade_name;
        this.getgetsubject();
      });
    },
    //获取科目
    getgetsubject() {
      var subjectval = {
        gid: this.Gid,
      };
      this.$post(URL.getsubject, subjectval).then((res) => {
        this.subjectdata = res.result.subject_list;
        this.form.sname = res.result.subject_list[0].subject_name;
        this.form.title = res.result.subject_list[0].subject_name.substring(
          0,
          1
        );
        this.form.region2 = res.result.subject_list[0].subject_name;
      });
      this.getbooklist();
    },
    //获取课本
    getbooklist() {
      var bookdata = {
        gid: this.Gid,
        sid: this.Sid,
      };
      this.$post(URL.getbooklist, bookdata).then((res) => {
        this.booklist = res.result.booklist;
        this.form.region3 = res.result.booklist[0].book_id;
        this.form.bookname = res.result.booklist[0].book_name;
        this.Bookid = res.result.booklist[0].book_id;
        this.getbookchapter();
      });
    },
    //课本内容
    getbookchapter() {
      var bookchapterdata = {
        cptid: this.Bookid,
      };
      this.$post(URL.bookchapter, bookchapterdata).then((res) => {
        this.taskdata = res.result.menu;
      });
    },
    //选择课本
    selectcourse() {
      this.dialogFormVisible = true;
    },
    //选择确定
    submitform() {
      this.dialogFormVisible = false;
    },
    //章节选择
    handleNodeClick(data) {},
  },
};
</script>
<style scoped>
body,
html,
div,
blockquote,
img,
label,
p,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
ul,
ol,
li,
dl,
dt,
dd,
form,
a,
fieldset,
input,
th,
td,
i,
em {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.inner {
  margin-top: 15px;
}
.subject-form {
  width: 200px;
}
</style>